import {onEnterPress, onSelect} from "../services/dom";

/**
 * Ajax Form
 * Will handle button clicks or input enter press events and submit
 * the data over ajax. Will always expect a partial HTML view to be returned.
 * Fires an 'ajax-form-success' event when submitted successfully.
 *
 * Will handle a real form if that's what the component is added to
 * otherwise will act as a fake form element.
 *
 * @extends {Component}
 */
class AjaxForm {
    setup() {
        this.container = this.$el;
        this.responseContainer = this.container;
        this.url = this.$opts.url;
        this.method = this.$opts.method || 'post';
        this.successMessage = this.$opts.successMessage;
        this.submitButtons = this.$manyRefs.submit || [];
        this.imagemap = '';
        this.count = 1;
        if (this.$refs.imagemap) {
            // this.imagemap = ImageMap(this.$refs.imagemap.id, 500);
        }
        if (this.$refs.addArea) {
            // ImageMap(this.$refs.addArea, 500);
            this.$refs.addArea.addEventListener('click', this.addNewArea.bind(this));
        }
        if (this.$refs.saveSvg) {
            // ImageMap(this.$refs.addArea, 500);
            this.$refs.saveSvg.addEventListener('click', this.saveSvg.bind(this));
        }
        if (this.$opts.responseContainer) {
            this.responseContainer = this.container.closest(this.$opts.responseContainer);
        }

        this.setupListeners();
    }

    setupListeners() {

        if (this.container.tagName === 'FORM') {
            this.container.addEventListener('submit', this.submitRealForm.bind(this));
            return;
        }

        onEnterPress(this.container, event => {
            this.submitFakeForm();
            event.preventDefault();
        });

        this.submitButtons.forEach(button => onSelect(button, this.submitFakeForm.bind(this)));
    }

    submitFakeForm() {
        const fd = new FormData();
        const inputs = this.container.querySelectorAll(`[name]`);
        for (const input of inputs) {
            fd.append(input.getAttribute('name'), input.value);
        }
        this.submit(fd);
    }

    submitRealForm(event) {
        event.preventDefault();
        const fd = new FormData(this.container);
        this.submit(fd);
    }

    saveSvg(event) {
        event.preventDefault();
        var arr = Array.prototype.slice.call(this.$refs.imagemaptag.areas);
        var imagesource = this.$refs.imagemap.src;
        var areas = {};
        for (const [key, value] of Object.entries(arr)) {
            var area = {};
            area.href = value.href;
            area.coords = value.coords;
            areas[key] = area;
        }
        var areajson = JSON.stringify(areas);

        const params = {
            area: areajson,
            imagesource: imagesource
        };

        const html = window.$http.get('generateSVG', params);

        setTimeout(function(){
            document.getElementsByClassName('image-manager-content-edit')[0].style.display = 'none';
            document.getElementsByClassName('image-manager-content-list')[0].style.display = 'flex';
            document.getElementsByClassName('tab-item-all')[0].click();
        }, 1000);
    }

    addNewArea(event) {
        let isNotValid = this.isUrlValid(this.$refs.imagemaphref.value) == false;
        if(this.$refs.imagemaphref.value == '') {
            this.$refs.imagemaphrefrequire.style.display = 'block';
            return false;
        }
        if(isNotValid) {
            this.$refs.imagemaphrefrequire.style.display = 'block';
            return false;
        }
        this.$refs.imagemaphrefrequire.style.display = 'none';
        let map = this.$refs.imagemaptag;
        let parentdiv = this.$refs.imagemapdiv;
        let area = document.createElement("AREA");
        let newdiv = document.createElement("div");
        newdiv.classList.add('popupDrag');
        var divid = 'dragable' + this.count;
        newdiv.id = divid;
        newdiv.style.top = 0;
        newdiv.style.left = 0;
        newdiv.innerHTML = '<div class="popupDrag-header">' + this.$refs.imagemaphref.value + '</div>';
        area.href = this.$refs.imagemaphref.value;
        area.dataset.name = 'dragable' + this.count;
        area.coords = "'" + this.$refs.imagemapx.value + "," + this.$refs.imagemapy.value + "," + this.$refs.imagemapheight.value + "," + this.$refs.imagemapwidth.value + "'";
        map.append(area);
        parentdiv.append(newdiv);
        this.initDragElement();
        this.initResizeElement();
        this.count++;
    }

    isUrlValid(userInput) {
        var regexQuery = "^(https?://)(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
        var url = new RegExp(regexQuery,"i");
        return url.test(userInput);
    }

    initDragElement() {
        var pos1 = 0,
            pos2 = 0,
            pos3 = 0,
            pos4 = 0;
        var popups = document.getElementsByClassName("popupDrag");
        var elmnt = null;
        var currentZIndex = 100; //TODO reset z index when a threshold is passed

        for (var i = 0; i < popups.length; i++) {
            var popup = popups[i];
            var header = getHeader(popup);

            popup.onmousedown = function () {
                this.style.zIndex = "" + ++currentZIndex;
            };

            if (header) {
                header.parentPopup = popup;
                header.onmousedown = dragMouseDown;
            }
        }

        function dragMouseDown(e) {
            elmnt = this.parentPopup;
            elmnt.style.zIndex = "" + ++currentZIndex;

            e = e || window.event;
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            if (!elmnt) {
                return;
            }
            ;
            e = e || window.event;
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            let x = elmnt.offsetTop - pos2;
            let y = elmnt.offsetLeft - pos1;
            // set the element's new position:
            elmnt.style.top = x + "px";
            elmnt.style.left = y + "px";
            let divid = elmnt.id;
            var areaName = document.querySelector(`[data-name="${divid}"]`);
            areaName.coords = "'" + x + "," + y + "," + elmnt.clientHeight + "," + elmnt.clientWidth + "'";
        }

        function closeDragElement() {
            /* stop moving when mouse button is released:*/
            document.onmouseup = null;
            document.onmousemove = null;
        }

        function getHeader(element) {
            var headerItems = element.getElementsByClassName("popupDrag-header");

            if (headerItems.length === 1) {
                return headerItems[0];
            }

            return null;
        }
    }

    initResizeElement() {
        var popups = document.getElementsByClassName("popupDrag");
        var element = null;
        var startX, startY, startWidth, startHeight;

        for (var i = 0; i < popups.length; i++) {
            var p = popups[i];

            var right = document.createElement("div");
            right.className = "resizer-right";
            p.appendChild(right);
            right.addEventListener("mousedown", initDrag, false);
            right.parentPopup = p;

            var bottom = document.createElement("div");
            bottom.className = "resizer-bottom";
            p.appendChild(bottom);
            bottom.addEventListener("mousedown", initDrag, false);
            bottom.parentPopup = p;

            var both = document.createElement("div");
            both.className = "resizer-both";
            p.appendChild(both);
            both.addEventListener("mousedown", initDrag, false);
            both.parentPopup = p;
        }

        function initDrag(e) {
            element = this.parentPopup;

            startX = e.clientX;
            startY = e.clientY;
            startWidth = parseInt(
                document.defaultView.getComputedStyle(element).width,
                10
            );
            startHeight = parseInt(
                document.defaultView.getComputedStyle(element).height,
                10
            );
            document.documentElement.addEventListener("mousemove", doDrag, false);
            document.documentElement.addEventListener("mouseup", stopDrag, false);
        }

        function doDrag(e) {
            element.style.width = startWidth + e.clientX - startX + "px";
            element.style.height = startHeight + e.clientY - startY + "px";
            let x = element.style.top;
            let y = element.style.left;
            let divid = element.id;
            var areaName = document.querySelector(`[data-name="${divid}"]`);
            areaName.coords = "'" + x + "," + y + "," + element.style.width + "," + element.style.height + "'";
        }

        function stopDrag() {
            document.documentElement.removeEventListener("mousemove", doDrag, false);
            document.documentElement.removeEventListener("mouseup", stopDrag, false);
        }
    }

    async submit(formData) {
        this.responseContainer.style.opacity = '0.7';
        this.responseContainer.style.pointerEvents = 'none';

        try {
            const resp = await window.$http[this.method.toLowerCase()](this.url, formData);
            this.$emit('success', {formData});
            this.responseContainer.innerHTML = resp.data;
            if (this.successMessage) {
                window.$events.emit('success', this.successMessage);
            }
        } catch (err) {
            this.responseContainer.innerHTML = err.data;
        }

        window.components.init(this.responseContainer);
        this.responseContainer.style.opacity = null;
        this.responseContainer.style.pointerEvents = null;
    }
}

export default AjaxForm;